export enum GamNavVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  HYPE = 'hype',
}

export enum GamNavSize {
  REGULAR = 'regular',
  SMALL = 'small',
}

export enum GamNavMyProfileSection {
  GENERAL = 'general',
  RATINGS = 'ratings',
  AVAILABILITY = 'availability',
  NOTIFICATION = 'notification',
  EMAIL_PREFERENCES = 'email_preferences',
  PLAN = 'plan',
  PAYMENT = 'payment',
  BLOCKED = 'blocked',
}

export enum GamNavProfileLinks {
  TERMS = 'terms',
  PRIVACY = 'privacy',
  IMPRINT = 'imprint',
  CONTACT = 'contact',
  APP_STORE = 'appstore',
  SOCIAL = 'social',
  MASTER = 'master',
  BUG = 'bug',
}

export enum GamLinksType {
  STATIC = 'static',
  EXTERNAL = 'external',
  MAIL = 'mail',
}
